import React, { Component } from 'react';
import PropTypes from 'prop-types';

const FUTURE_DAY_COLOR = '#EAEAEA';

class CalendarDay extends Component {

  componentDidMount () {
    if (!this.tooltipster && this._tooltip()) {
      this._initializeTooltip();
    }
  }

  componentDidUpdate () {
    if (this.tooltipster && this._tooltip()) {
      this.tooltipster.content(this._tooltip());
    } else if (!this.tooltipster && this._tooltip()) {
      this._initializeTooltip();
    } else if (this.tooltipster) {
      this.tooltipster.destroy();
    }
  }

  componentWillUnmount () {
    if (this.tooltipster) {
      this.tooltipster.destroy();
    }
  }

  _initializeTooltip () {
    $(this.svg).tooltipster({
      animationDuration: 100,
      contentAsHTML: true,
      delay: 100,
      theme: 'tooltipster-borderless',
      functionInit (instance, helper) {
        const $origin = $(helper.origin);
        let dataOptions = $origin.attr('data-tooltip-config');
        if (dataOptions) {
          dataOptions = JSON.parse(dataOptions);
          $.each(dataOptions, (name, option) => {
            instance.option(name, option);
          });
        }
      },
    });
    this.tooltipster = $(this.svg).tooltipster('instance');
  }

  _fill () {
    if (this.props.color) {
      return this.props.color;
    }
    return FUTURE_DAY_COLOR;
  }

  _tooltip () {
    return this.props.tooltip;
  }

  render () {
    return (
      <svg className="day" width="32" height="32" xmlns="http://www.w3.org/2000/svg" ref={el => this.svg = el} title={this._tooltip()}>
        <rect className={this.props.hidden ? 'hide' : null} width="32" height="32" fill={this._fill()} />
      </svg>
    );
  }
}

CalendarDay.propTypes = {
  hidden: PropTypes.bool,
  tooltip: PropTypes.string,
  color: PropTypes.string,
};

export default CalendarDay;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/status/calendar_day.jsx